interface Props {
  type: 'hr' | 'min' | 'sec'
  left: number | string
}

const typeToText: Record<Props['type'], string> = {
  hr: 'H',
  min: 'M',
  sec: 'S',
}

export const TimeBox = ({ type, left }: Props) => {
  return (
    <div className="mr-1 w-[58px] rounded-md border border-secondary-500 bg-secondary-600 px-3 py-1 text-white last:mr-0">
      <span className="whitespace-nowrap text-sm">
        {left} {typeToText[type]}
      </span>
    </div>
  )
}
